export default __webpack_public_path__ + "static/media/wizard.64df0d5f.svg";